import BigBurger from "../../img/BigBurger.png";
import steak from "../../img/steak.png";
import Fish from "../../img/Fish.png";


export const SliderData = [
    {
        image: `${BigBurger}`,
        heading: "DELICIOUS BURGERS",
        text: "Grilled premium quality beef and unforgettable flavor of special sauces",
        link: "See Menu"
    },
    {
        image: `${steak}`,
        heading: "STEAK",
        text: "Grilled premium quality beef and unforgettable flavor of special sauces",
        link: "See Menu"
    },
    {
        image: `${Fish}`,
        heading: "SALMON",
        text: "Grilled premium quality salmon and unforgettable flavor of special sauces",
        link: "See Menu"
    }
]